<template>
  <div class="upload-doc-modal-creare-contract-wrapper">
    <el-button
      v-if="contragentContracts"
      type="primary"
      style="margin-bottom: 16px; margin-right: 12px; width: 235px"
      @click="showModal"
    >
      Перейти к загрузке файлов
    </el-button>
    <el-button
      v-else
      style="margin-bottom: 16px; margin-right: 12px; width: 235px"
      :loading="loadingContracts"
      type="success"
      @click="createContract"
    >
      Создать контракт
    </el-button>
    <span class="wrapper-choise-type">
      <el-select
        v-model="documents_workflow"
        class="wrapper-choise-type_select"
        placeholder="Выберите тип документооборота"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :disabled="item.value === 'undefined'"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-button
        :disabled="loadingContracts || !contragentContracts"
        :loading="loadingContracts"
        type="warning"
        @click="updatedTypeContarct"
      >
        Сохранить тип
      </el-button>
    </span>

    <el-dialog
      v-if="isShowModal"
      :before-close="checkForm"
      :title="'Договор с ' + short_name"
      :visible.sync="isShowModal"
      :width="widthDialog"
      :append-to-body="true"
      :close-on-click-modal="false"
      class="upload-doc-modal"
      @opened="onDialogOpened"
    >
      <el-collapse>
        <el-collapse-item title="Создать новый документ">
          <new-additionals-form
            v-if="contragentContracts"
            :contract-id="contragentContracts && contragentContracts.id"
            :loading-contracts="loadingContracts"
            @createDocument="createdDocument"
          />
        </el-collapse-item>
      </el-collapse>
      <new-contract-list
        v-if="contragentContracts.documents.length > 0"
        :loading-contracts="loadingContracts"
        :documents="contragentContracts.documents"
        :contract-id="contragentContracts.id"
        :approvement-contract-id="approvedContract ? approvedContract.id : null"
        @deleteDocument="deleteDocument"
        @signDocument="signDocument"
        @setActiveDocument="setActiveDocument"
        @deleteFile="deleteFile"
        @uploadedImages="uploadedImagesFile"
        @getZip="getZip"
        @saveNumber="saveNumber"
      />
    </el-dialog>
  </div>
</template>

<script>
import { documents_workflow } from '@/helpers/typeContract'
import newAdditionalsForm from '@/components/Upload/newAdditionalsForm'
import newContractList from './components/newContractList'

export default {
  name: 'UploadDocAndCreateContractModal',
  components: {
    newAdditionalsForm,
    newContractList,
  },
  props: {
    contragentContracts: {
      type: Object,
      default: () => {},
    },
    short_name: {
      type: String,
    },
    inn: {
      type: String,
    },

    loadingContracts: {
      type: Boolean,
      default: false,
    },
    nameDocument: {
      type: String,
      default: '',
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      options: documents_workflow,
      documents_workflow:
        this.contragentContracts?.documents_workflow || 'undefined',
      form: {},
      advancedFormModel: {},
      document: '',
      fileExpire: '',
      formNameDocument: '',
      pastedFile: null,
      isApprove: 0,
      isShowModal: false,
      isFileList: false,
      approvedContract: null,
    }
  },
  computed: {
    documentId() {
      return this.document ? this.document?.id : 0
    },
    issetDocument() {
      return Boolean(this.document)
    },
    fileList() {
      return this.document ? this.document?.files : []
    },
    countFiles() {
      let count = 0

      if (this.document.files) {
        count = this.document.files.length
      }

      return count
    },
    noFiles() {
      // могут добавлять файлы ?
      return !this.canUpload && (!this.document || this.countFiles === 0)
    },
    uploadFiles() {
      return this.canUpload && !this.approvedContract
    },
  },
  watch: {
    contragentContracts: {
      immediate: true,
      handler(value) {
        this.documents_workflow = value?.documents_workflow || 'undefined'
      },
    },
  },
  methods: {
    updatedTypeContarct() {
      this.$emit('updatedTypeContarct', {
        documents_workflow: this.documents_workflow,
        id: this.contragentContracts?.id,
      })
    },
    getZip(id) {
      this.$emit('getedZip', id)
    },
    deleteFile(data) {
      this.$emit('deletedFile', data)
    },
    saveNumber(data) {
      this.$emit('savedNumber', {
        ...data,
        contract_id: this.contragentContracts.id,
      })
    },
    uploadedImagesFile(param1, param2) {
      this.$emit('uploadImages', param1, param2)
    },
    deleteDocument(data) {
      this.$emit('deletedDocument', data)
    },
    signDocument(data) {
      this.$emit('signedDocument', data)
    },
    setActiveDocument(data) {
      this.$emit('setedActiveDocument', data)
    },
    canUpload() {
      return this.$canAction('uploadFilesAuto', this.userInfo)
    },

    getApproveOneDoc(documents) {
      // если есть аппрув док то берем только его, если нет то берем первый попавшийся ибо все равно не будет правильного
      let documentItem

      for (let key in documents) {
        if (documentItem === undefined) {
          documentItem = documents[key]
        }
        if (documents[key].approve_status.length !== 0) {
          documentItem = documents[key]
        }
      }
      this.document = documentItem
      this.$emit('ready', this.document)
    },
    createContract() {
      if (this.$canAction('createDocAuto', this.userInfo)) {
        this.$emit('createdContract')
      }
    },
    createdDocument(data) {
      if (this.$canAction('createDocAuto', this.userInfo)) {
        this.$emit('createdDocument', data)
      }
    },
    checkForm(done) {
      window.removeEventListener('paste', this.handlePaste)
      done()
    },
    showModal() {
      this.isShowModal = true
    },
    uploaded(file) {
      this.fileList.unshift(file)
      this.pastedFile = null
      window.addEventListener('paste', this.handlePaste)
    },
    onDialogOpened() {
      window.addEventListener('paste', this.handlePaste)
    },
    handlePaste(ev) {
      const items = (ev.clipboardData || ev.originalEvent.clipboardData).items

      for (let i in items) {
        let item = items[i]

        if (item.kind === 'file') {
          let blob = item.getAsFile()
          let allowedFormats = ['image/jpeg', 'image/png']
          let isSize = blob.size / 1024 / 1024 < 15

          if (!allowedFormats.includes(blob.type)) {
            this.$alert(
              'Ошибка при загрузке файла ' + blob.name + '. Неверный формат',
            )
          }
          if (!isSize) {
            this.$alert(
              'Ошибка при загрузке файла ' + blob.name + '. Превышен размер',
            )
          }
          if (isSize && allowedFormats.includes(blob.type)) {
            this.pastedFile = blob
          }
        }
      }
    },
    onStartUpload() {
      window.removeEventListener('paste', this.handlePaste)
    },
    onAborted() {
      window.addEventListener('paste', this.handlePaste)
    },
  },
}
</script>

<style lang="sass">
.upload-doc-modal-creare-contract-wrapper
  display: flex
  align-items: center
.upload-doc-modal
  font-family: "Rubik", sans-serif
  .el-collapse-item__header
    font-weight: bold
    font-size: 1.1em
    color: #67C23A
  .box-card
    z-index: 5000 !important
    position: fixed
    left: 0
    top: 0
    width: 20%
    background-color: white
  .help_upload
    padding-left: 10px !important
    color: #a5a5a5
    font-size: 15px
    font-family: "Rubik", sans-serif
  .help_upload li
    padding-top: 5px
  .el-alert--success
    font-weight: bold !important
    cursor: pointer !important
.wrapper-choise-type
  display: flex
  width: 420px
  margin-bottom: 16px
  &_select
    width: 90%
    display: block
    margin-right: 8px
</style>
